export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12595.2fbe1c51.jpg";